<template>
	<div class="card">
		<h2>You don't have access to this module at the current time.</h2>
		<h3>{{ this.$route.query.page }}</h3>
	</div>
</template>
